// apps/client/src/ui/world3d/surfaces.ts
export const biomePalettes = {
  river: {
    ground: "#778451",
    sand: "#b7ad86",
    rock: 0x90907a,
    cap: 0xaaa18a,
    leaf: 0x34543c,
    cliff: 48,
    sky: 0xb4c2b1,
  },
  industrial: {
    ground: "#747367",
    sand: "#9f967d",
    rock: 0x65696b,
    cap: 0xaaa69a,
    leaf: 0x454f3f,
    cliff: 80,
    sky: 0xa6b1b6,
  },
  badlands: {
    ground: "#b59162",
    sand: "#d0b27e",
    rock: 0x995b3e,
    cap: 0xd0a16c,
    leaf: 0x69714d,
    cliff: 110,
    sky: 0xd0b894,
  },
  coastal: {
    ground: "#627956",
    sand: "#c0b78d",
    rock: 0x7b8b83,
    cap: 0xa2a58e,
    leaf: 0x3b6050,
    cliff: 40,
    sky: 0xa4c4c6,
  },
  frontier: {
    ground: "#b4c0b9",
    sand: "#bbc4be",
    rock: 0x75838b,
    cap: 0xe0e7e5,
    leaf: 0x375a50,
    cliff: 145,
    sky: 0xb7cbd4,
  },
  temperate: {
    ground: "#626b46",
    sand: "#a4936e",
    rock: 0x777668,
    cap: 0x959481,
    leaf: 0x465e32,
    cliff: 42,
    sky: 0xa3ad9b,
  },
  mesa: {
    ground: "#ad8759",
    sand: "#bd9866",
    rock: 0x8e573b,
    cap: 0xc0915f,
    leaf: 0x696241,
    cliff: 110,
    sky: 0xc3ac8d,
  },
  alpine: {
    ground: "#858f83",
    sand: "#a3a7a0",
    rock: 0x626b70,
    cap: 0xd5deda,
    leaf: 0x304d45,
    cliff: 135,
    sky: 0xb7cbd4,
  },
  wetlands: {
    ground: "#52664a",
    sand: "#7b7d59",
    rock: 0x637266,
    cap: 0x879077,
    leaf: 0x365d3d,
    cliff: 35,
    sky: 0x94b2a2,
  },
  caldera: {
    ground: "#56544f",
    sand: "#7a6a5a",
    rock: 0x393c40,
    cap: 0x71716b,
    leaf: 0x595c43,
    cliff: 95,
    sky: 0xa7a39b,
  },
} as const;

// apps/client/src/ui/world3d/terrain.ts
export const terrainColors: Record<string, string> = {
  ground: "#62634b",
  sand: "#ad9a6a",
  road: "#55574f",
  water: "#596d5f",
  bridge: "#697066",
  rock: "#777663",
  trees: "#434c35",
};
